import React, { Component } from "react";
import { connect } from "react-redux";
import { Container, Row, Col } from "reactstrap";

import "./style.css";
import historyActions from "../../redux/history/action";
import PageHead from "../../component/pageHead/PageHead";
import InputComp from "../../component/InputComp/InputComp";
import CustomButton from "../../component/CustomButton/CustomButton";
import api from "../../config/api";
import authAction from "../../redux/auth/action";
import CustomLoader from "../../component/CustomLoader/CustomLoader";
import { isNetworkRequestFailedError } from "../../config/helpers";

class ChangePassword extends Component {
  state = {
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
    isLoading: false,
  };

  componentDidMount() {
    const { history, setHistory } = this.props;
    setHistory(history);
  }

  submit = async () => {
    this.setState({ isLoading: true });
    const { currentPassword, newPassword, confirmPassword } = this.state;
    const { user, setAlertMessage } = this.props;
    const body = {
      OldPassword: currentPassword,
      NewPassword: newPassword,
      ConfirmPassword: confirmPassword,
    };

    if (!currentPassword || !newPassword || !confirmPassword) {
      setAlertMessage({ type: "error", message: "All Fields Are Required" });
      this.setState({
        newPassword: "",
        confirmPassword: "",
        currentPassword: "",
        isLoading: false,
      });
      return;
    }

    if (newPassword !== confirmPassword) {
      setAlertMessage({
        type: "error",
        message: "New password and confirm password should be same",
      });
      this.setState({ confirmPassword: "", newPassword: "", isLoading: false });
      return;
    }

    try {
      const response = await api.changePassword(body, user.token);
      if (response.data.ErrorMessage) {
        const errorMessage = response.data.ErrorMessage;
        setAlertMessage({ type: "error", message: errorMessage });
        this.setState({
          newPassword: "",
          confirmPassword: "",
          currentPassword: "",
        });
      } else {
        setAlertMessage({
          type: "success",
          message: "Password successfully changed",
        });
        this.setState({
          newPassword: "",
          confirmPassword: "",
          currentPassword: "",
        });
      }
    } catch (e) {
      setAlertMessage({
        type: "error",
        message: e.message,
        onTryAgain: isNetworkRequestFailedError(e) ? this.submit : null,
      });
    }
    this.setState({ isLoading: false });
  };

  render() {
    const { currentPassword, newPassword, confirmPassword, isLoading } =
      this.state;
    return (
      <Container>
        <PageHead containerStyles={{ width: "100%" }} title="CHANGE PASSWORD" />
        {isLoading && <CustomLoader text={"Changing Password"} />}
        <InputComp
          type="password"
          name="password"
          value={currentPassword}
          containerStyles={{ width: "100%" }}
          placeholder="Current Password"
          onChange={(e) => {
            this.setState({ currentPassword: e.target.value });
          }}
        />
        <InputComp
          type="password"
          name="new password"
          value={newPassword}
          containerStyles={{ width: "100%" }}
          placeholder="New Password"
          onChange={(e) => {
            this.setState({ newPassword: e.target.value });
          }}
        />
        <InputComp
          type="password"
          name="confirm password"
          value={confirmPassword}
          containerStyles={{ width: "100%" }}
          placeholder="Confirm Password"
          onChange={(e) => {
            this.setState({ confirmPassword: e.target.value });
          }}
        />
        <Row className="my-2 justify-content-center">
          <Col className="p-0" sm={5} md={3}>
            <CustomButton
              buttonClasses="btn-block"
              buttonText="Submit"
              onClick={() => {
                this.submit();
              }}
            />
          </Col>
        </Row>
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
});

const mapDispatchToProps = {
  setHistory: historyActions.setHistory,
  setAlertMessage: authAction.setAlertMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword);
